import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Search, ShoppingBag, CreditCard, Truck, Users, Settings, FileQuestion } from "lucide-react";
import { WhatsAppIcon } from "@/components/ui/whatsapp-icon";
import { Link } from "react-router-dom";

const HelpCenter = () => {
  const categories = [
    {
      icon: <ShoppingBag className="h-6 w-6" />,
      title: "Orders & Shopping",
      description: "Track orders, manage cart, product questions",
      link: "/help/orders"
    },
    {
      icon: <CreditCard className="h-6 w-6" />,
      title: "Payments & Refunds",
      description: "Payment methods, refund process, billing",
      link: "/refund-policy"
    },
    {
      icon: <Truck className="h-6 w-6" />,
      title: "Shipping & Delivery",
      description: "Shipping rates, delivery times, tracking",
      link: "/shipping-info"
    },
    {
      icon: <Users className="h-6 w-6" />,
      title: "Account & Security",
      description: "Account settings, password, security",
      link: "/help/account"
    },
    {
      icon: <WhatsAppIcon className="h-6 w-6" size={24} />,
      title: "WhatsApp Integration",
      description: "Connect WhatsApp, messaging, notifications",
      link: "/help/whatsapp"
    },
    {
      icon: <Settings className="h-6 w-6" />,
      title: "Seller Tools",
      description: "Product listing, inventory, analytics",
      link: "/seller/dashboard"
    }
  ];

  const faqs = [
    {
      question: "How do I track my order?",
      answer: "You can track your order by visiting the Track Order page or through your account dashboard."
    },
    {
      question: "What payment methods are accepted?",
      answer: "We accept credit/debit cards, bank transfers, and mobile money through Paystack."
    },
    {
      question: "How long does delivery take?",
      answer: "Delivery typically takes 2-5 business days within Lagos and 3-7 business days for other states."
    },
    {
      question: "Can I cancel my order?",
      answer: "Orders can be cancelled within 24 hours of placement if they haven't been shipped yet."
    },
    {
      question: "How do I become a seller?",
      answer: "Register for a seller account and choose a subscription plan that suits your business needs."
    }
  ];

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold mb-4">How can we help you?</h1>
          <div className="max-w-md mx-auto relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-muted-foreground" />
            <Input 
              placeholder="Search for help..." 
              className="pl-10"
            />
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mb-12">
          {categories.map((category, index) => (
            <Link to={category.link} key={index}>
              <Card className="p-6 hover:shadow-lg transition-shadow cursor-pointer">
                <div className="text-primary mb-3">{category.icon}</div>
                <h3 className="font-semibold mb-2">{category.title}</h3>
                <p className="text-sm text-muted-foreground">{category.description}</p>
              </Card>
            </Link>
          ))}
        </div>

        <Card className="p-6">
          <div className="flex items-center gap-2 mb-6">
            <FileQuestion className="h-6 w-6 text-primary" />
            <h2 className="text-2xl font-semibold">Frequently Asked Questions</h2>
          </div>
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="border-b pb-4 last:border-0">
                <h3 className="font-medium mb-2">{faq.question}</h3>
                <p className="text-muted-foreground text-sm">{faq.answer}</p>
              </div>
            ))}
          </div>
        </Card>

        <div className="mt-8 text-center">
          <p className="text-muted-foreground mb-4">Still need help?</p>
          <Link to="/contact">
            <button className="bg-primary text-primary-foreground px-6 py-2 rounded-md hover:bg-primary/90 transition-colors">
              Contact Support
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default HelpCenter;